// @ts-strict-ignore
import { combineReducers } from 'redux';
import { TimelineEvent } from '@/types';
import {
    INSERT_TIMELINE_EVENT,
    TryInsertTimelineEventAction,
    TryUpdateTimelineEventsAction,
    UPDATE_TIMELINE_EVENTS,
} from '@/actions/timelineEvents';

interface TimelineEventsByStepRunId {
    [id: string]: {
        [id: string]: TimelineEvent;
    };
}

type timelineEventsActionTypes = TryUpdateTimelineEventsAction | TryInsertTimelineEventAction;

function timelineEventsByStepRunId(state: TimelineEventsByStepRunId = {}, action: timelineEventsActionTypes) {
    switch (action.type) {
        case UPDATE_TIMELINE_EVENTS: {
            const newState = {
                ...state,
            };
            const timelineEvents = action.payload;

            for (const timelineEvent of timelineEvents) {
                newState[timelineEvent.workflowRunId] = {
                    ...newState[timelineEvent.workflowRunId],
                    [timelineEvent.stepRunId]: {
                        ...newState[timelineEvent.workflowRunId]?.[timelineEvent.stepRunId],
                        [timelineEvent.triggeredAt + timelineEvent.type]: timelineEvent,
                    },
                };
            }
            return newState;
        }

        case INSERT_TIMELINE_EVENT: {
            const timelineEvent = action.payload;
            const newState = { ...state };

            newState[action.payload.workflowRunId] = {
                ...newState[action.payload.workflowRunId],
                [timelineEvent.stepRunId]: {
                    // Differently from the updateTimelineEvents action, we add the timeline event to beginning of the array
                    [timelineEvent.triggeredAt + timelineEvent.type]: timelineEvent,
                    ...newState[action.payload.workflowRunId]?.[timelineEvent.stepRunId],
                },
            };

            return newState;
        }

        default:
            return state;
    }
}

export const timelineEventsReducer = combineReducers({
    byId: timelineEventsByStepRunId,
});
